var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (_s, groups, partner, undefined) {
buf.push("<div class=\"partner2-artists-grid\">");
// iterate groups
;(function(){
  var $$obj = groups;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var group = $$obj[$index];

buf.push("<section class=\"partner2-overview-section artists-grid-section\"><h3 class=\"partner2-overview-section-title artists-group-label\">" + (jade.escape(null == (jade_interp = _s.titleize(group.label)) ? "" : jade_interp)) + "</h3><div class=\"partner2-artists-container\">");
// iterate group.list
;(function(){
  var $$obj = group.list;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var pa = $$obj[$index];

if ( pa.get('published_artworks_count') > 0 && pa.get('display_on_partner_profile') === true)
{
buf.push("<figure" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + " class=\"partner2-artist\"><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\"><div class=\"partner2-artist-cover-image\"><img" + (jade.attr("src", "" + (pa.imageUrl('four_thirds')) + "", true, true)) + (jade.attr("alt", pa.get('artist').name, true, true)) + "><div class=\"partner2-artist-overlay\"></div></div><figurecaption class=\"partner2-artist-caption\"><h5 class=\"partner2-artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</h5></figurecaption></a></figure>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var pa = $$obj[$index];

if ( pa.get('published_artworks_count') > 0 && pa.get('display_on_partner_profile') === true)
{
buf.push("<figure" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + " class=\"partner2-artist\"><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\"><div class=\"partner2-artist-cover-image\"><img" + (jade.attr("src", "" + (pa.imageUrl('four_thirds')) + "", true, true)) + (jade.attr("alt", pa.get('artist').name, true, true)) + "><div class=\"partner2-artist-overlay\"></div></div><figurecaption class=\"partner2-artist-caption\"><h5 class=\"partner2-artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</h5></figurecaption></a></figure>");
}
    }

  }
}).call(this);

buf.push("</div></section>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var group = $$obj[$index];

buf.push("<section class=\"partner2-overview-section artists-grid-section\"><h3 class=\"partner2-overview-section-title artists-group-label\">" + (jade.escape(null == (jade_interp = _s.titleize(group.label)) ? "" : jade_interp)) + "</h3><div class=\"partner2-artists-container\">");
// iterate group.list
;(function(){
  var $$obj = group.list;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var pa = $$obj[$index];

if ( pa.get('published_artworks_count') > 0 && pa.get('display_on_partner_profile') === true)
{
buf.push("<figure" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + " class=\"partner2-artist\"><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\"><div class=\"partner2-artist-cover-image\"><img" + (jade.attr("src", "" + (pa.imageUrl('four_thirds')) + "", true, true)) + (jade.attr("alt", pa.get('artist').name, true, true)) + "><div class=\"partner2-artist-overlay\"></div></div><figurecaption class=\"partner2-artist-caption\"><h5 class=\"partner2-artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</h5></figurecaption></a></figure>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var pa = $$obj[$index];

if ( pa.get('published_artworks_count') > 0 && pa.get('display_on_partner_profile') === true)
{
buf.push("<figure" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + " class=\"partner2-artist\"><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\"><div class=\"partner2-artist-cover-image\"><img" + (jade.attr("src", "" + (pa.imageUrl('four_thirds')) + "", true, true)) + (jade.attr("alt", pa.get('artist').name, true, true)) + "><div class=\"partner2-artist-overlay\"></div></div><figurecaption class=\"partner2-artist-caption\"><h5 class=\"partner2-artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</h5></figurecaption></a></figure>");
}
    }

  }
}).call(this);

buf.push("</div></section>");
    }

  }
}).call(this);

buf.push("<section class=\"artists-grid-section\"><div class=\"partner2-artists-see-all avant-garde-header-center\"><a" + (jade.attr("href", "" + (partner.href()) + "/artists", true, true)) + " class=\"faux-underline-hover partner2-route-link\">Go to artists</a></div></section></div>");}.call(this,"_s" in locals_for_with?locals_for_with._s:typeof _s!=="undefined"?_s:undefined,"groups" in locals_for_with?locals_for_with.groups:typeof groups!=="undefined"?groups:undefined,"partner" in locals_for_with?locals_for_with.partner:typeof partner!=="undefined"?partner:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;